import { createSelector } from 'reselect'
import { isEmpty, groupBy } from 'lodash-es'
import { DateTime } from 'luxon'

const formatDate = (date) =>
  DateTime.fromSQL(date).toISO({ suppressMilliseconds: true }) ?? ''

const formatComments = (comments) => {
  if (isEmpty(comments)) {
    return []
  }

  return [...comments.values()].map((comment) => {
    const date = comment.creation_date_ansi || comment.entry_date_ansi

    return { ...comment, dateFormatted: formatDate(date) }
  })
}

// eslint-disable-next-line import-x/no-default-export
export default ({ getFeatureRoot }) => {
  const getQuestionComments = (state) =>
    getFeatureRoot(state).questions.comments

  const getQuestions = createSelector([getQuestionComments], (questions) =>
    formatComments(questions)
  )

  const getQuestionGroupedByStatus = createSelector(
    getQuestionComments,
    (questions) => groupBy([...questions.values()], 'comment_status')
  )

  return {
    getQuestions,
    getQuestionGroupedByStatus,
  }
}
